import { CommonAuthorizationService } from '@savgroup-front-common/core/api/Authorization/AuthorizationService';

import {
  deleteApiApplication,
  getApiApplication,
  setApiApplication,
  updateApiApplication,
} from './apiCredentials';
import { getAssignablePermissionsByCategoryQuery } from './getAssignablePermissionsByCategoryQuery';
import getFeatureFlagsByIdQuery from './getFeatureFlagsByIdQuery';
import getOneTimeTokenQuery from './getOneTimeTokenQuery';
import getUser from './getUser';
import getUserInformationByIdQuery from './getUserInformationByIdQuery';
import getUserInformationByIdsQuery from './getUserInformationByIdsQuery';
import getUsersInformationBySellerIdQuery from './getUsersInformationBySellerIdQuery';
import inviteUserCommand from './inviteUserCommand';
import listManagementUsersQuery from './listManagementUsersQuery';
import listUserSiteQuery from './listUserSiteQuery';
import setMyUserConsoleModeForSellerCommand from './setMyUserConsoleModeForSellerCommand';
import { setUserPreferenceCommand } from './setUserPreferenceCommand';
import upsertFeatureFlagsCommand from './upsertFeatureFlagsCommand';
import { deleteUserProfileCommand } from './user/deleteUserProfileCommand';
import setUserProfilesToUser from './user/setUserProfilesToUser';
import { unlinkUserFromSellerCommand } from './user/unlinkUserFromSellerCommand';
import upsertUserManagementCommand from './user/upsertUserManagementCommand';
import { upsertUserProfileCommand } from './user/upsertUserProfileCommand';

const AuthorizationService = {
  listManagementUsersQuery,
  getUserInformationByIdQuery,
  getUserInformationByIdsQuery,
  listUserSiteQuery,
  getUsersInformationBySellerIdQuery,
  upsertFeatureFlagsCommand,
  setApiApplication,
  deleteApiApplication,
  updateApiApplication,
  getApiApplication,
  setUser: upsertUserManagementCommand,
  upsertUserManagementCommand,
  setUserProfilesToUser,
  getUser,
  getFeatureFlagsQuery: CommonAuthorizationService.getFeatureFlagsQuery,
  getFeatureFlagsByIdQuery,
  getOneTimeTokenQuery,
  inviteUserCommand,
  getConfigurableRolesQuery:
    CommonAuthorizationService.getConfigurableRolesQuery,

  pagedListManagementUsersQuery:
    CommonAuthorizationService.pagedListManagementUsersQuery,
  listUserProfileQuery: CommonAuthorizationService.listUserProfileQuery,
  unlinkUserFromSellerCommand,
  upsertUserProfileCommand,
  deleteUserProfileCommand,
  setMyUserConsoleModeForSellerCommand,
  setUserPreferenceCommand,
  getAssignablePermissionsByCategoryQuery,
};

export default AuthorizationService;
